import { Link } from "react-router-dom";
import { PauseCircle, Loader2, Lock } from "lucide-react";
import { useGames, gameOn, gameBlocked } from "@/lib/games";

const NAMES = { wheel: "Glücksrad", scratch: "Rubbellose", lotto: "Punkte-Lotto", teams: "Team-Duell", pet: "Haustier", mood: "Stimmung & Tagebuch", duels: "Punkte-Duelle", treasure: "Schatzsuche", goldrain: "Goldregen" };

export const BlockedNote = ({ game }) => {
  const c = useGames()?.[game] || {};
  return (
  <div className="rounded-3xl bg-white border border-red-100 p-6 text-center space-y-2" data-testid={`game-blocked-${game}`}>
    <Lock className="w-10 h-10 mx-auto text-red-400" />
    <p className="text-xs font-bold uppercase tracking-wider text-red-400">{NAMES[game]}</p>
    <p className="font-display text-lg font-extrabold text-slate-800">Du bist für dieses Spiel gesperrt</p>
    {c.blocked_until && <p className="text-sm text-slate-500" data-testid={`game-blocked-until-${game}`}>bis {new Date(c.blocked_until).toLocaleString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" })} Uhr</p>}
    {c.blocked_reason && <p className="text-xs text-slate-400" data-testid={`game-blocked-reason-${game}`}>Grund: {c.blocked_reason}</p>}
  </div>
  );
};

export function GameGate({ game, children }) {
  const cfg = useGames();
  if (!cfg) return <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-rose-500" /></div>;
  if (gameOn(cfg, game) && gameBlocked(cfg, game)) return <div className="max-w-md mx-auto py-16"><BlockedNote game={game} /></div>;
  if (gameOn(cfg, game)) return children;
  return (
    <div className="max-w-md mx-auto text-center py-16 space-y-3" data-testid={`game-paused-${game}`}>
      <PauseCircle className="w-12 h-12 mx-auto text-rose-400" />
      <h1 className="font-display text-2xl font-extrabold">Gerade pausiert</h1>
      <p className="text-sm text-slate-500">Dieses Spiel macht gerade eine kleine Pause. Schau bald wieder vorbei!</p>
      <Link to="/spiele" data-testid="game-paused-back" className="inline-flex h-11 px-6 items-center rounded-full pink-gradient text-white font-bold text-sm">Zu den Spielen</Link>
    </div>
  );
}
